module.exports = __webpack_public_path__ + "img/pin-ruby.7a8fb247.png";